import PropTypes from "prop-types";
//import { addonsTypes } from './addonsTypes';

export const addonsContainerDefaultProps = {
  addonsByPaxIndex: []
};

export const addonsContainerTypes = {
  isRtl: PropTypes.bool,
  addonsByPaxIndex: PropTypes.array,
  actions: PropTypes.object,
  selectedPaxId: PropTypes.number,
  selectedAddonsGroup: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/types/addonsTypes/addonsContainerTypes.js